module.exports = __webpack_public_path__ + "img/scan.dec0f4b5.jpeg";